// frontend/util/plan-costs.js
// Lines for the plan card's "Other costs" that need more than a field read.
import { money } from '~/util/string'

// Medicare.gov's "Total Drug & Premium Cost (for <year>)" for a drug plan: a
// year of premiums plus the estimated drug costs at the pharmacy the plan was
// priced at. Both halves come from the store's parsePlan: the effective-date
// total for a plan starting mid-year, else the full-year one. Mid-year, oracle
// prices only the months left (the pharmacy's monthly estimates start at the
// effective date), so the line says "the rest of" the year.
export function totalDrugPremiumCost (plan, year) {
    if (!plan || !plan.pdp) { return null }
    const effective = plan.effective_date_estimated_yearly_cost
    const total = Number.isFinite(effective) ? effective : plan.estimated_yearly_cost
    if (!Number.isFinite(total)) { return null }
    const ph = plan.cheapest_pharmacy
    const months = ph?.estimated_monthly_costs?.length
    const partial = months
        ? months < 12
        : Number.isFinite(plan.effective_date_annual_premium) && Number.isFinite(plan.annual_premium) && plan.effective_date_annual_premium < plan.annual_premium - 0.005
    const when = `${partial ? 'the rest of ' : ''}${plan.year || year}`
    const note = !ph
        ? 'Premiums only: no prescriptions on file'
        : ph.pharmacy?.npi === 'mail_order'
            ? 'Premiums plus estimated drug costs by mail order'
            : `Premiums plus estimated drug costs at ${ph.pharmacy?.name || 'your pharmacy'}`
    return { text: `${money(total)} total drug & premium cost for ${when}`, value: total, note }
}
